import React, { useState, useEffect, useCallback, useContext } from "react";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import { Box, Typography, makeStyles } from "@material-ui/core";

// import FormControl from "@mui/material/FormControl";
// import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ListSubheader from "@mui/material/ListSubheader";
import Button from "@mui/material/Button";
import update from "immutability-helper";
import { useNavigate } from "react-router-dom";

import AlertDialog from "../../../components/AlertDialog.js";

import imgRes from "../../../assets/positionImgs/res.png";
import footField from "../../../assets/positionImgs/football_field.png";
import { Selection } from "./Selection";
import { createStyles, Theme } from "@material-ui/core/styles";
import { REFRESH_TOKEN_MUTATION } from "../../../graphQL/user_qry";
import { ItemTypes } from "../../../store/data/ItemTypes";
import { POSITIONS_DATA } from "../../../store/data/DummyData";
import { GET_LEAGUE_FORMATIONS_QUERY } from "../../../graphQL/formationToLeague_qry";
import { project_url } from "../../../store/data/Constants";

var findAnd = require("find-and");

const FIXTUREOBJTEAMS_QUERY = `query fixtureObjectTeams($fixtureId:Int!){
  fixtureObjectTeams(fixtureId:$fixtureId){
    fixtureTeamId
    fixtureId{
      fixtureId
      lock
      fixtureWeek{
        scheduledDate
      }
      scheduledWeek{
        scheduledDate
      }
    }
    sleagueTeamId{
      sleagueTeamId
      teamId{
        name
        shortName
        logo
      }
    }
    scoreFinal
    home
    coachSeq
  }
}`;

const ADD_USER_TS = `mutation addUserTS($fixtureTeamId: Int!,  $userSeq: String!) {
  addUserTS(
    fixtureTeamId: $fixtureTeamId,

    userSeq: $userSeq,
  ) {
    userTS{
      userTSId
      userSeq
    }
  }
}`;

const UPDATE_USER_TS = `mutation updateUserTS($userTSId: Int!, $userSeq: String!) {
  updateUserTS(
    userTSId: $userTSId,
    userSeq: $userSeq,
  ) {
    userTS{
      userTSId
      userSeq
    }
  }
}`;

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  },

  formationStyle: {
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: 18,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#4D4D4D",
  },
}));

const MyTeamInfo = ({
  userData,
  userFavTeam,
  fixtureTeamId,
  sleagueTeamId,
  fixtureId,
  leagueId,
  userSeqData,
  userSeqVal,
  userTSId,
  embargoTime,
  sleaguePlayers,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [players, setPlayers] = useState([]);
  const [formations, setFormations] = useState();
  const [selectedFormation, setSelectedFormation] = useState("");
  const [droppedPlayerNames, setDroppedPlayerNames] = useState([]);
  const [teamSelections, setTeamSelections] = useState([]);
  const [embargoTimeStatus, setEmbargoTimeStatus] = useState(false);
  const [selectedFormationTitle, setSelectedFormationTitle] = useState("");
  const [isLoad, setIsLoad] = useState(false);
  const [fixtureTeamsData] = useManualQuery(FIXTUREOBJTEAMS_QUERY);
  const [addUserTeam] = useMutation(ADD_USER_TS);
  const [updateUserTeam] = useMutation(UPDATE_USER_TS);
  const [pathname] = useState(window.location.pathname);

  const mainPath = "/lms/media/";

  const {
    loading: leagueFormationsDataLoading,
    error: leagueFormationsDataError,
    data: leagueFormationsData,
  } = useQuery(GET_LEAGUE_FORMATIONS_QUERY, {
    variables: {
      leagueId: leagueId,
    },
  });

  useEffect(() => {
    let userSeq = userSeqVal.slice(0, 2);
    if (userSeq !== "") setSelectedFormation(userSeq);
  }, [userSeqVal]);
  useEffect(() => {
    setPlayers(
      sleaguePlayers.map(player => {
        let name = player.playerId.name;
        let onFieldName = player.playerId.onFieldName;
        let position = player.playerId.position;
        let jerseyNO = player.jerseyNO;
        let playerSeqNO = player.playerSeqNO;
        let type = ItemTypes.PLAYER;
        return { name,onFieldName, position, jerseyNO, playerSeqNO, type };
      })
    );
  }, [sleaguePlayers]);

  useEffect(() => {
    let findPositionsData = POSITIONS_DATA.find(x => {
      return x.formationSeqNo === selectedFormation;
    });
    if (!findPositionsData) return [];

    let resFound = [];
    let droppedPlayerNamesVal = [];
    let draftTeamSelections = findPositionsData.positionsData;
    let val = "";
    ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"].map(i => {
      switch (i) {
        case "01":
          val = userSeqVal.slice(4, 6);
          break;
        case "02":
          val = userSeqVal.slice(8, 10);
          break;
        case "03":
          val = userSeqVal.slice(12, 14);
          break;
        case "04":
          val = userSeqVal.slice(16, 18);
          break;
        case "05":
          val = userSeqVal.slice(20, 22);
          break;
        case "06":
          val = userSeqVal.slice(24, 26);
          break;
        case "07":
          val = userSeqVal.slice(28, 30);
          break;
        case "08":
          val = userSeqVal.slice(32, 34);
          break;
        case "09":
          val = userSeqVal.slice(36, 38);
          break;
        case "10":
          val = userSeqVal.slice(40, 42);
          break;
        case "11":
          val = userSeqVal.slice(44, 46);
      }

      resFound = findAnd.returnFound(players, {
        playerSeqNO: val,
      });

      if (resFound) {
        draftTeamSelections = findAnd.changeProps(
          draftTeamSelections,
          { positionSeqNo: i },
          {
            lastDroppedItem: {
              name: resFound.name,
	            onFieldName: resFound.onFieldName,
              jerseyNO: resFound.jerseyNO,
              playerSeqNO: resFound.playerSeqNO,
            },
          }
        );
        droppedPlayerNamesVal.push(resFound.name);
      }
    });
    setDroppedPlayerNames(droppedPlayerNamesVal);
    setTeamSelections(draftTeamSelections);
    //passTeamSelectionsData(droppedPlayerNamesVal, draftTeamSelections);
  }, [players]);

  useEffect(() => {
    const formationsList = [];
    const parentFormations = [];

    if (
      !leagueFormationsDataLoading &&
      leagueFormationsData &&
      leagueFormationsData.leagueFormation
    ) {
      leagueFormationsData.leagueFormation.map(leagueFrm => {
        if (!parentFormations.includes(leagueFrm.formationId.formationPrimary)) {
          parentFormations.push(leagueFrm.formationId.formationPrimary);
        }
      });

      parentFormations.map((formation, i) => {
        formationsList.push({ mainCategory: formation });
        let derivedFormations = leagueFormationsData.leagueFormation.filter(frm => {
          return frm.formationId.formationPrimary === formation;
        });
        formationsList[i].derivedCategories = derivedFormations;
      });
    }
    var resFound = findAnd.returnFound(formationsList, {
      formationSeqNO: selectedFormation,
    });
    if (resFound) setSelectedFormationTitle(resFound.title);
    setFormations(formationsList);
  }, [leagueFormationsData, selectedFormation]);

  // const renderSelectGroup = formation => {
  //   const items = formation.derivedCategories.map(f => {
  //     return (
  //       <MenuItem style={{paddingLeft:30,fontSize: 14}} key={f.formationId.formationSeqNO}
  //         value={f.formationId.formationSeqNO}>
  //         {f.formationId.title}
  //       </MenuItem>
  //     );
  //   });
  //   return [
  //     <ListSubheader
  //       style={{
  //         color: "black",
  //         fontSize: 14,
  //         fontWeight: "bold",
  //         backgroundColor: "white",
  //         marginLeft: 0,
  //       }}
  //     >
  //       {formation.mainCategory}
  //     </ListSubheader>,
  //     items,
  //   ];
  // };

  useEffect(() => {
    const loadImage = image => {
      return new Promise((resolve, reject) => {
        const loadImg = new Image();
        loadImg.src = image;
        // wait 500 milliseconds to simulate loading time
        loadImg.onload = () =>
          setTimeout(() => {
            resolve(image);
          }, 200);
        loadImg.onerror = err => {
          reject(err);
        };
      });
    };
    let IMAGES = [];
    if (teamSelections) {
      if (teamSelections.GK) IMAGES.push(imgRes, teamSelections.GK[0].img);
      if (teamSelections.DEF && teamSelections.DEF.defLane_col_1)
        teamSelections.DEF.defLane_col_1.map(i => IMAGES.push(i.img));
      if (teamSelections.DEF && teamSelections.DEF.defLane_col_2)
        teamSelections.DEF.defLane_col_2.map(i => IMAGES.push(i.img));
      if (teamSelections.MID && teamSelections.MID.midLane_col_1)
        teamSelections.MID.midLane_col_1.map(i => IMAGES.push(i.img));
      if (teamSelections.MID && teamSelections.MID.midLane_col_2)
        teamSelections.MID.midLane_col_2.map(i => IMAGES.push(i.img));
      if (teamSelections.MID && teamSelections.MID.midLane_col_3)
        teamSelections.MID.midLane_col_3.map(i => IMAGES.push(i.img));
      if (teamSelections.FOR && teamSelections.FOR.forLane_col_1)
        teamSelections.FOR.forLane_col_1.map(i => IMAGES.push(i.img));
      if (teamSelections.FOR && teamSelections.FOR.forLane_col_2)
        teamSelections.FOR.forLane_col_2.map(i => IMAGES.push(i.img));
    }
    if (IMAGES.length == 0) return;
    Promise.all(IMAGES.map(img => loadImage(img)))
      .then(() => setIsLoad(true))
      .catch(err => console.log("Failed to load images", err));
  }, [teamSelections]);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  const client = useContext(ClientContext);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`/lms/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate("/lms/signout");
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
    }
  };

  return (
    <Box mt={3} mb={2} className={classes.container}>
      {!isLoad ? (
        <div
          style={{
            backgroundImage: `url(${footField})`,
            width: 580,
            height: 408,
          }}
        />
      ) : (
        <div
          style={{
            display: "flex",
            float: "left",
          }}
        >
          <div
            style={{
              flexDirection: "row",
              display: "flex",
            }}
          >
            <div
              style={{
                //  overflow: "hidden",
                clear: "both",
              }}
            >
              {teamSelections.GK &&
                teamSelections.GK.map(
                  ({ accepts, lastDroppedItem, text, img, height, width }, index) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                        />
                      </div>
                    );
                  }
                )}
            </div>
            {teamSelections.DEF && teamSelections.DEF.defLane_col_1 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.DEF.defLane_col_1.map(
                  ({ accepts, lastDroppedItem, text, img, height, width }, index) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            {teamSelections.DEF && teamSelections.DEF.defLane_col_2 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.DEF.defLane_col_2.map(
                  ({ accepts, lastDroppedItem, text, img, height, width }, index) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            {teamSelections.MID && teamSelections.MID.midLane_col_1 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.MID.midLane_col_1.map(
                  ({ accepts, lastDroppedItem, text, img, height, width }, index) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            {teamSelections.MID && teamSelections.MID.midLane_col_2 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.MID.midLane_col_2.map(
                  ({ accepts, lastDroppedItem, text, img, height, width }, index) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            {teamSelections.MID && teamSelections.MID.midLane_col_3 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.MID.midLane_col_3.map(
                  ({ accepts, lastDroppedItem, text, img, height, width }, index) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            {teamSelections.FOR && teamSelections.FOR.forLane_col_1 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.FOR &&
                  teamSelections.FOR.forLane_col_1.map(
                    ({ accepts, lastDroppedItem, text, img, height, width }, index) => {
                      return (
                        <div>
                          <Selection
                            key={index}
                            accept={accepts}
                            img={img}
                            height={height}
                            width={width}
                            text={text}
                            lastDroppedItem={lastDroppedItem}
                          />
                        </div>
                      );
                    }
                  )}
              </div>
            )}
            {teamSelections.FOR && teamSelections.FOR.forLane_col_2 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.FOR.forLane_col_2.map(
                  ({ accepts, lastDroppedItem, text, img, height, width }, index) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            <div
              style={{
                height: 408,
                width: 29,
                backgroundImage: `url(${imgRes})`,
                //backgroundRepeat: "no-repeat",
                flexDirection: "column",
                //border: "1px solid white"
              }}
            />
          </div>
        </div>
      )}

      <Box mt={3} mb={2}>
        <Typography className={classes.formationStyle}>
          Formation: {selectedFormationTitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default MyTeamInfo;
